export default __webpack_public_path__ + "static/media/köide-34-35.13486226.png";